<template>
  <div>
    <van-nav-bar
      title="宝乐记账-选择区域"
      right-text="退出"
      :fixed="navFixed"
      :placeholder="navPlaceholder"
      @click-right="logout"
    />
    <ul class="butContainer">
      <li v-for="(item,index) in getAreaList" :key="index">
        <el-button plain type="info" style="width:70%;text-overflow: ellipsis;overflow: hidden;" @click="jumper(item)">{{ item.area_name }}</el-button>
      </li>
    </ul>
  </div>

</template>
<script>
import { NavBar } from 'vant'
import { List } from 'vant'
import { Toast } from 'vant'
import { getAreaList } from '@/api/user'

export default {
  name: 'Index',
  components: {
    [NavBar.name]: NavBar,
    [List.name]: List,
    [Toast.name]: Toast
  },
  data() {
    return {
      getAreaList: [],
      container: null,
      navFixed: true,
      navPlaceholder: true

    }
  },
  mounted() {
    // this.container = this.$refs.container
  },
  created() {
    this.getList()
  },
  methods: {
    logout() {
      this.$store.dispatch('user/logout')
      this.$router.push('/login')
    },
    jumper(data) {
      this.$router.push({ path: this.redirect || '/driver/address', query: { id: data.id, name: data.area_name }})
    },
    getList() {
      const data = Object.assign({})
      data.is_all = 1

      getAreaList(data).then(response => {
        this.getAreaList = response.data.list
      })
      console.log(this.getAreaList)
    }
  }
}
</script>
<style lang="scss" scoped>
    .butContainer {
        text-align: center;
        vertical-align: middle;
        margin: 1% 0;

        li {
            margin-top: 0.5rem;
        }
    }
</style>
